import React, { useState } from 'react'
import { Button } from '@nextui-org/button'
import Banner from 'assets/images/app/BannerMKT.png'
import toast from 'react-hot-toast'
import PropTypes from 'prop-types'

const Result = ({ result, resetSimulator }) => {
  const [visible, setVisible] = useState(false)
  const [enabled, setEnabled] = useState(true)

  const copyToClipboard = () => {
    navigator.clipboard.writeText(result.replaceAll('.', ''))
  }

  return (
    <div className="flex flex-col items-center space-y-9">
      <Button
        type="submit"
        color="danger"
        size="lg"
        className={`font-bold rounded-3xl bg-[#D930CD] w-fit px-9 shadow-lg shadow-pink-300 animate-fade-left animate-duration-1000`}
        isDisabled={!enabled}
        onClick={() => {
          copyToClipboard()
          setEnabled(false)
          setTimeout(() => setEnabled(true), 2000)
          toast.success('Copiado al portapapeles')
        }}
      >
        {result === '0' ? 'Exento' : `$${result} clp`}
      </Button>
      <img
        onClick={() => {
          window.open('https://ww2.propital.com/servicioslegales', '_blank', 'noopener noreferrer')
        }}
        src={Banner}
        alt="Banner"
        className={`${
          visible ? 'animate-fade animate-duration-1000' : 'invisible'
        } h-[200px] w-auto object-contain`}
        onLoad={() => setVisible(true)}
      />
      <div>
        <Button
          type="submit"
          color="primary"
          size="lg"
          onClick={() => {
            window.open(
              'https://ww2.propital.com/servicioslegales',
              '_blank',
              'noopener noreferrer',
            )
          }}
          className={`font-bold rounded-3xl w-fit px-9 animate-fade-right animate-duration-1000`}
          variant="shadow"
        >
          Quiero asesoría contable
        </Button>
        <p
          className="mt-4 text-sm text-center cursor-pointer text-primary"
          onClick={() => resetSimulator()}
        >
          Volver a calcular
        </p>
      </div>
    </div>
  )
}

Result.propTypes = {
  result: PropTypes.any.isRequired,
  resetSimulator: PropTypes.func.isRequired,
}

export default Result
